const actions = {

    STORE_DASHBOARD_DATA_BEGIN : 'STORE_DASHBOARD_DATA_BEGIN',
    STORE_DASHBOARD_DATA_SUCCESS: 'STORE_DASHBOARD_DATA_SUCCESS',
    STORE_DASHBOARD_DATA_ERR : 'STORE_DASHBOARD_DATA_ERR',

    DASHBOARD_RECENT_ACTIVITY_BEGIN: 'DASHBOARD_RECENT_ACTIVITY_BEGIN',
    DASHBOARD_RECENT_ACTIVITY_SUCCESS: 'DASHBOARD_RECENT_ACTIVITY_SUCCESS',
    DASHBOARD_RECENT_ACTIVITY_ERR: 'DASHBOARD_RECENT_ACTIVITY_ERR',

    storeDashboardDataBegin: () => {
        return {
            type: actions.STORE_DASHBOARD_DATA_BEGIN,
        };
    },

    storeDashboardDataSuccess: (data) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },

    storeDashboardDataErr: (err) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_ERR,
            err,
        };
    },

    dashboardRecentActivityBegin: () => {
        return {
            type: actions.DASHBOARD_RECENT_ACTIVITY_BEGIN,
        };
    },

    dashboardRecentActivitySuccess: (data) => {
        return {
            type: actions.DASHBOARD_RECENT_ACTIVITY_SUCCESS,
            data,
        };
    },

    dashboardRecentActivityErr: (err) => {
        return {
            type: actions.DASHBOARD_RECENT_ACTIVITY_ERR,
            err,
        };
    },
};

export default actions;
